import { Element, Icon } from '@zmedia/bm-soccer-ui/components';
import { memo, useCallback } from 'react';
import {
    ICON_MATCH_EVENT,
    IEvent,
    MATCH_EVENT,
} from '@zmedia/bm-soccer-ui/interface';
import styles from './style.module.scss';

export function EventPlayer({ events = [] }: { events?: IEvent[] }) {
    if (!events.length) {
        return null;
    }
    const eventsGoal = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.GOAL;
    });
    const eventsOwnGoal = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.OWN_GOAL;
    });
    const eventsGoalPenalty = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.PENALTY_GOAL;
    });
    const eventsMissPenalty = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.MISSED_PENALTY;
    });
    const eventsAssist = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.ASSIST;
    });
    const eventsYellowCard = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.YELLOW_CARD;
    });
    const eventsSecondYellowCard = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.YELLOW_CARD_2ND;
    });
    const eventsRedCard = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.RED_CARD;
    });

    const eventSubstitution = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.SUBSTITUTION;
    });

    const eventsInjury = events.filter((event: IEvent) => {
        return event.type.id === MATCH_EVENT.INJURY;
    });

    const renderEventsGoal = useCallback(() => {
        return eventsGoal?.map((event: IEvent, index: number) => {
            return (
                <Icon
                    key={event.type.id + index}
                    icon={ICON_MATCH_EVENT.GOAL}
                />
            );
        });
    }, [eventsGoal]);

    const renderEventsOwnGoal = useCallback(() => {
        return eventsOwnGoal?.map((event: IEvent, index: number) => {
            return (
                <Icon
                    key={event.type.id + index}
                    icon={ICON_MATCH_EVENT.OWN_GOAL}
                />
            );
        });
    }, [eventsGoal]);

    return (
        <Element className={styles['player-events']}>
            {eventsGoal.length > 0 && (
                <Element className={styles['event-goal']}>
                    {renderEventsGoal()}
                </Element>
            )}

            {eventsGoalPenalty.length > 0 && (
                <Element className={styles['event-goal']}>
                    <Icon icon={ICON_MATCH_EVENT.PENALTY_GOAL} />
                </Element>
            )}

            {eventsOwnGoal.length > 0 && (
                <Element className={styles['event-goal']}>
                    {renderEventsOwnGoal()}
                </Element>
            )}

            {eventsAssist.length > 0 && (
                <Element className={styles['event-assist']}>
                    <Icon icon={ICON_MATCH_EVENT.ASSIST} />
                </Element>
            )}

            {eventsMissPenalty.length > 0 && (
                <Element className={styles['event-miss-penalty']}>
                    <Icon icon={ICON_MATCH_EVENT.MISSED_PENALTY} />
                </Element>
            )}

            {eventsYellowCard.length > 0 && (
                <Element className={styles['event-card']}>
                    <Icon icon={ICON_MATCH_EVENT.YELLOW_CARD} />
                </Element>
            )}

            {eventsSecondYellowCard.length > 0 && (
                <Element className={styles['event-card']}>
                    <Icon icon={ICON_MATCH_EVENT.YELLOW_CARD_2ND} />
                </Element>
            )}

            {eventsRedCard.length > 0 && (
                <Element className={styles['event-card']}>
                    <Icon icon={ICON_MATCH_EVENT.RED_CARD} />
                </Element>
            )}

            {eventSubstitution.length > 0 && (
                <Element className={styles['event-substitution']}>
                    <Icon icon={ICON_MATCH_EVENT.SUBSTITUTION_OUT} />
                </Element>
            )}

            {eventsInjury.length > 0 && (
                <Element className={styles['event-injury']}>
                    <Icon icon={ICON_MATCH_EVENT.INJURY} />
                </Element>
            )}
        </Element>
    );
}

export default memo(EventPlayer);
